var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-alert",
        {
          staticClass: "p-5",
          attrs: {
            variant: "danger",
            dismissible: "",
            show: _vm.error.isVisible
          },
          on: {
            dismissed: function($event) {
              _vm.error.isVisible = false
            }
          }
        },
        [
          _c(
            "i18n",
            { attrs: { path: "error.resetPasswordConfirm.submit" } },
            [
              _c(
                "b-link",
                {
                  attrs: {
                    href: "mailto:support@meine-vertraege.net",
                    place: "supportLink"
                  }
                },
                [_vm._v("support@meine-vertraege.net")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "rounded-0" },
        [
          _c("h4", [
            _vm._v(_vm._s(_vm.$t("message.resetPasswordConfirm.title")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.resetPasswordConfirm.message")))
          ]),
          _vm._v(" "),
          _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit($event)
                }
              }
            },
            [
              _c(
                "b-form-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.confirmData.password.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.resetPasswordConfirm.password"
                            )
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "message.resetPasswordConfirm.label.password"
                                  )
                                ) +
                                "\n              "
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t(
                                "message.resetPasswordConfirm.input.placeholder.password"
                              ),
                              state: _vm.$v.confirmData.password.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.confirmData.password.$touch()
                              }
                            },
                            model: {
                              value: _vm.confirmData.password,
                              callback: function($$v) {
                                _vm.$set(_vm.confirmData, "password", $$v)
                              },
                              expression: "confirmData.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.confirmData.passwordConfirm.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.resetPasswordConfirm.passwordConfirm"
                            )
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "message.resetPasswordConfirm.label.passwordConfirm"
                                  )
                                ) +
                                "\n              "
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t(
                                "message.resetPasswordConfirm.input.placeholder.passwordConfirm"
                              ),
                              state: _vm.$v.confirmData.passwordConfirm.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.confirmData.passwordConfirm.$touch()
                              }
                            },
                            model: {
                              value: _vm.confirmData.passwordConfirm,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.confirmData,
                                  "passwordConfirm",
                                  $$v
                                )
                              },
                              expression: "confirmData.passwordConfirm"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-5" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.confirmData.verificationCode.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.resetPasswordConfirm.verificationCode"
                            )
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "message.resetPasswordConfirm.label.verificationCode"
                                  )
                                ) +
                                "\n              "
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "message.resetPasswordConfirm.input.placeholder.verificationCode"
                              ),
                              state: _vm.$v.confirmData.verificationCode.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.confirmData.verificationCode.$touch()
                              }
                            },
                            model: {
                              value: _vm.confirmData.verificationCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.confirmData,
                                  "verificationCode",
                                  $$v
                                )
                              },
                              expression: "confirmData.verificationCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-5" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-btn",
                        { attrs: { variant: "link" }, on: { click: _vm.back } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.resetPasswordConfirm.btn.back")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-btn",
                        { attrs: { variant: "primary", type: "submit" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.resetPasswordConfirm.btn.send")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37c5561d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37c5561d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ResetPasswordConfirm.vue
// module id = 7xBm
// module chunks = 1